import React from 'react'
import styled from 'styled-components'
import Wallet from '@Components/Wallet/Wallet'

type Props = {
	opened: boolean
	onClose: () => void
}

/**
 * The slide-in wallet panel. Kept as a direct child of the header container so
 * it still anchors just below the header on the right — only the thing that
 * opens it moved (see WalletChip).
 */
const WalletPanel: React.FC<Props> = ({ opened, onClose }) => {
	return (
		<PanelAnchor>
			<PanelBody opened={opened}>
				<Wallet onFinish={onClose} />
			</PanelBody>
		</PanelAnchor>
	)
}

export default WalletPanel

const PanelAnchor = styled.div`
	position: absolute;
	right: 0;
	top: 100%;
	z-index: 10;
`

const PanelBody = styled.div<{ opened: boolean }>`
	min-height: 70vh;
	width: 90vw;
	display: grid;
	grid-template-rows: auto minmax(0, 1fr);
	max-height: calc(100vh - 80px);
	overflow: hidden;
	background: ${props => props.theme.colors.independence};
	color: ${props => props.theme.colors.light};
	padding: 1.5rem 1.5rem;
	position: absolute;
	top: 0;
	right: ${props => (props.opened ? '0' : '-100vw')};
	transition: all ease-in-out 400ms;
	border-bottom-left-radius: ${props => props.theme.borderRadii.medium}px;
	${({ theme }) => `${theme.mediaQueries.large}{
		width :30vw;
	}`}
`
